<div class="row" [formGroup]="payrollScheduleForm">
  <div [ngClass]="payType == 0 ? 'col-12' : 'col-6'">
    <label class="fw-bold">Type of Payroll</label>
    <div class="form-control" disabled="disabled">{{ PayTypeLabel }}</div>
  </div>

  <div *ngIf="payType != 0" class="col-6">
    <label class="fw-bold" for="label">Reason</label>
    <div *ngIf="activePayroll != null" class="form-control" disabled="disabled">
      {{ activePayroll.Label }}
    </div>
    <fieldset [disabled]="locked">
      <select
        *ngIf="!activePayroll"
        class="form-control"
        formControlName="Label"
        id="label"
        data-testid="payLabelInput">
        <option></option>
        <option *ngFor="let label of payrollLabels" [ngValue]="label.Value">
          {{ label.Value }}
        </option>
      </select>
      <div *ngIf="f.Label.errors?.required && !activePayroll?.Label" class="input-error">
        *required
      </div>
    </fieldset>
  </div>
  <div class="row mx-0 px-0" [formArrayName]="'Schedules'">
    <div class="col-6 fw-bold">
      <label>Schedule</label>
    </div>
    <div class="col-6 fw-bold">
      <label>Period End</label>
    </div>

    <ng-container *ngFor="let schedule of selectedSchedules; index as i">
      <div class="col-6">
        <div class="form-control" disabled="disabled">{{ schedule.ScheduleName }}</div>
      </div>
      <div class="col-6">
        <div class="input-group" [formGroupName]="i">
          <input
            class="form-control datepicker"
            ngbDatepicker
            #pick="ngbDatepicker"
            required
            [placement]="['bottom-end', 'top-end']"
            [firstDayOfWeek]="7"
            formControlName="periodEnd"
            id="{{ 'periodEndPicker_' + i }}"
            data-testid="periodEndInput" />
          <div
            *ngIf="getScheduleControls(i).periodEnd.errors?.required"
            class="input-error input-group-error">
            *required
          </div>
          <div
            *ngIf="
              getScheduleControls(i).periodEnd.errors &&
              !getScheduleControls(i).periodEnd.errors?.required
            "
            class="input-error input-group-error">
            *invalid date
          </div>
          <img src="assets/icons/calendar.svg" class="icon-append" (click)="pick.toggle()" />
        </div>
      </div>
    </ng-container>
  </div>

  <div class="col-12">
    <label class="fw-bold">Pay Date</label>
    <div *ngIf="!activePayroll && selectedSchedules.length">
      <fieldset [disabled]="payrollStartConfig.Unsupported?.length > 1 || activePayroll != null">
        <div class="input-group">
          <input
            formControlName="PayDate"
            class="form-control datepicker"
            ngbDatepicker
            [placement]="['bottom-end', 'top-end']"
            #payDateDatePicker="ngbDatepicker"
            [firstDayOfWeek]="7"
            [minDate]="minimumAvailableDate"
            data-testid="payDateInput" />
          <div
            *ngIf="f.PayDate?.errors?.required && !f.PayDate?.value"
            class="input-error input-group-error">
            *required
          </div>
          <div
            class="input-error input-group-error"
            *ngIf="
              !f.PayDate?.valid &&
              f.PayDate?.value &&
              !f.PayDate?.errors?.holiday &&
              !f.PayDate?.errors?.sunday &&
              !f.PayDate?.errors?.past
            ">
            *invalid date
          </div>
          <div *ngIf="f.PayDate?.errors?.past" class="input-error input-group-error">
            *pay date must be on or after {{ renderTodaysDate() }}
          </div>
          <div *ngIf="f.PayDate?.errors?.holiday" class="input-error input-group-error">
            *pay date cannot land on a holiday
          </div>
          <div *ngIf="f.PayDate?.errors?.sunday" class="input-error input-group-error">
            *pay date cannot land on a Sunday
          </div>
          <img
            src="assets/icons/calendar.svg"
            (click)="payDateDatePicker.toggle()"
            class="icon-append" />
        </div>
      </fieldset>
    </div>
    <div *ngIf="activePayroll" class="form-control" disabled="disabled">
      {{ activePayroll.PayDate | date: 'MM/dd/yyyy' }}
    </div>
  </div>
</div>
